import React, { Component } from 'react'
import { Row, Col, Card, Image,Button,Container,Media } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Cookies from "es-cookie";
import moment from 'moment';
import { withRouter } from "react-router-dom";
import ViewSyllabus from './ViewSyllabus';
import './_repeatersExams.scss';
import UserRestrictionAlert from "../../home/UserRestrictionAlert";

class RepeatersExamsSections extends Component {
    constructor(props) {
        super(props)
        this.state = {
            examTypeString:"ongoing",
            activeOngoingExamType:"active",
            activeAttendedExamType:"",
            activeMissedExamType:"",
            getExamsNewPattern:"",
            viewSyllabusModal:false,
            viewSyllabusDetails:"",
            accessCourseModules:props.getCourseModuleAccess?.getCourseModuleAccess,
            userRestionModalShow: false,
            examAcess:0,
            currentTime: moment().unix()

        }
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
  
        }
        
    }

    modalFunAssignments = () => {
        this.setState({
            userRestionModalShow: true,
        });
    }

    startExam = (data) => {
        localStorage.setItem("mocklivestatus", "");

        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("mocktest", true);
        localStorage.setItem("resumeExam", false);
        localStorage.setItem("examtype_pattern", "series_test_pattern");
        window.open("/student/subject/series_test", "_blank");


    }

    resumeExam = (data) => {
        //console.log("this.state.subtype", data.exam_name, data.exam_name);
        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("mocktest", true);
        localStorage.setItem("examtype_pattern", "series_test_pattern");
        localStorage.setItem("resumeExam", true);
        window.open("/student/subject/series_test", "_blank");

        // this.props.history.push({
        //     pathname: "/student/subject/series_test",

        // })
        this.props.history.push({
            pathname: "/student/home",

        })

    }

 
    handleResultFunction = (id) => {

        this.props.history.push({
            pathname: "/student/subject/exam-result",
            state: {
                sessionid: id,
                examtype: "series_test_pattern",
                //mocktype: "history"

            }
        })
    }
    handleShowModal =  (data) => {
        console.log(data)
        this.setState({
            viewSyllabusModal: true,
            viewSyllabusDetails:data
        });
    }
    handleSelect = (examType) => {
        let activeOngoingExamType="",activeAttendedExamType="",activeMissedExamType=""
        this.setState({
            examTypeString:"",
            activeOngoingExamType:"",
            activeAttendedExamType:"",
            activeMissedExamType:""
        });

        if(examType == "ongoing"){
            activeOngoingExamType = `active`;
        }else if(examType == "attended"){
            activeAttendedExamType = `active`;
        }else if(examType == "missed"){
            activeMissedExamType = `active`;
        }

        this.setState({
            examTypeString: examType,
            activeOngoingExamType:activeOngoingExamType,
            activeAttendedExamType:activeAttendedExamType,
            activeMissedExamType:activeMissedExamType,
        });

    }
    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
      }
    render() {
        
        const currentPlanId = this.isStudentUserValid.current_plan_id;
        const epriryDateInunixTime = this.isStudentUserValid.expiry_date;
        const currentDateInUnixTime = parseInt((new Date().getTime() / 1000).toFixed(0))
        console.log("this.state.accessCourseModules",parseInt(currentPlanId))
        if(this.state.accessCourseModules != undefined){
            this.state.accessCourseModules.map((item,index) => {
                item.courseModuleAccess.map((item1,index)=> {
                    if(currentPlanId == item1.student_plan_id || parseInt(currentPlanId) == 25 || parseInt(currentPlanId) == 27 ){
                        if (currentDateInUnixTime > epriryDateInunixTime) {
                            this.state.examAcess= 0
                        }else{
                            this.state.examAcess= 1
                        }
                        
                    }
                    
                    
                })
               
            });
        }

        let currentDateTime = moment().unix();
        const endofdate = moment(moment(moment().unix() * 1000).endOf('day').unix() * 1000).unix();
        let currentTime_currentSec = Math.round((new Date()).getTime() / 1000);

        let ongoingExams = this.props.getStudentTestSeriesNewPattern?.filter(item=> (( (currentDateTime > item.start_time && currentDateTime <= item.end_time && item.is_completed == false) || (currentDateTime < item.start_time))))
        let attendedExams = this.props.getStudentTestSeriesNewPattern?.filter(item=> item.is_completed == true)
        let missedExams = this.props.getStudentTestSeriesNewPattern?.filter(item=> currentDateTime > item.end_time && item.is_completed != true)

        if(this.state.examTypeString == "ongoing"){
            console.log("ongoingExams",ongoingExams);
            this.state.getExamsNewPattern = ongoingExams
        }else if(this.state.examTypeString == "attended"){
            console.log("attendedExams",attendedExams)
            this.state.getExamsNewPattern = attendedExams
        }else if(this.state.examTypeString == "missed"){
            console.log("missedExams",missedExams)
            this.state.getExamsNewPattern = missedExams
        }
       
         console.log("this.state.examsLength",this.state.examsLength)
         console.log("this.state.examsLength",this.state.getExamsNewPattern)
         console.log("this.state.examAcess",this.state.examAcess)
        return (
            <Container fluid>
                <Row>
                    <Col sm={12} className="bg_color_blue">
                        <ul className="list-inline exam_types_li">
                            <li className={this.state.activeOngoingExamType} onClick={() => this.handleSelect("ongoing")}>Ongoing</li>
                            <li className={this.state.activeAttendedExamType} onClick={() => this.handleSelect("attended")} >Attended </li>
                            <li className={this.state.activeMissedExamType} onClick={() => this.handleSelect("missed")} >Missed </li>
                        </ul>
                    </Col>
                </Row>
                
                <Row>
                    <Col sm={12}>
                        <div className="exams_pattern_bg mt-4">
                            <Row>
                                {
                                    this.state.getExamsNewPattern.map((item,index) =>
                                        <Col sm={6} className="mt-2">
                                            <Card className="card-border-exams">
                                                <Card.Body>
                                                <Media>
                                                    <div className="date_block mr-3 text-center">
                                                        <p className="mt-1 f-22 border-bootom2"> {moment.unix(item.start_time).format("MMM")}</p>
                                                        <p className="mt-2 f-22">{moment.unix(item.start_time).format("DD")}</p>
                                                    </div>       
                                                        <Media.Body>
                                                            {
                                                                currentDateTime > item.start_time && currentDateTime <= item.end_time ?
                                                                (
                                                                    item.is_completed == true || item.exam_expired == true ?
                                                                    (<Card.Title><h6 className="f-14">{item.exam_name}</h6></Card.Title>)
                                                                    :
                                                                    (<Card.Title><h6 className="f-14">{item.exam_name} <span className="float-right live-class">Live</span></h6></Card.Title>)
                                                                    
                                                                )
                                                                :
                                                                (<Card.Title><h6 className="f-14">{item.exam_name}</h6></Card.Title>)
                                                            }
                                                            
                                                            <Row>
                                                                <Col sm={7}>
                                                                    <p className="f-14">Time : {moment.unix(item.start_time).format("LT")} to {moment.unix(item.end_time).format("LT")}</p>
                                                                </Col>
                                                                <Col sm={5}>
                                                                    <p className="float-right-resp f-14"> Duration : {item.exam_duration}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm={6} className="mt-2">
                                                                    <Button type="button" className="btn btn-blue-exam" onClick={() => this.handleShowModal(item)}>View Syllabus</Button>
                                                                </Col>
                                                                <Col sm={6} className="mt-2">

                                                                    {
                                                                        item.exam_expired == true ?
                                                                        (
                                                                            <h6 className="red_color float-right-resp" >Exam Expired </h6>
                                                                        )
                                                                        :
                                                                        (
                                                                            <>
                                                                            {
                                                                                item.is_completed == true ?
                                                                                (
                                                                                    <Button type="button" className="btn btn-blue-exam float-right-resp" onClick={() => this.handleResultFunction(item.exam_session_id)}>View Results </Button>
                                                                                )
                                                                                :
                                                                                (
                                                                                    currentDateTime > item.end_time ?
                                                                                    ("")
                                                                                    :
                                                                                    (
                                                                                        moment.unix(item.start_time).format("DD-MMM-YYYY") == moment.unix(currentTime_currentSec).format("DD-MMM-YYYY") && parseInt(item.start_time-600) < parseInt(currentTime_currentSec) ?
                                                                                        (
                                                                                            this.state.examAcess == 1  ?

                                                                                            (
                                                                                                item.is_started == true && currentTime_currentSec > item.start_time ? 
                                                                                                (<Button type="button" className="btn btn-blue-exam float-right-resp" onClick={() => this.resumeExam(item)}>Resume Test</Button>):

                                                                                                (<Button type="button" className="btn btn-blue-exam float-right-resp" onClick={() => this.startExam(item)}>Start Now</Button>)
                                                                                                
                                                                                        )
                                                                                            :
                                                                                            (
                                                                                                <Button type="button" className="btn btn-blue-exam float-right-resp" onClick={() => this.modalFunAssignments()}>Start Now</Button>

                                                                                                
                                                                                            )
                                                                                        )
                                                                                        :
                                                                                        (
                                                                                            this.state.examAcess == 1 ?
                                                                                            (<Button type="button" className="btn btn-blue-exam float-right-resp" disabled>Start Now</Button>)
                                                                                            :
                                                                                            (<Button type="button" className="btn btn-blue-exam float-right-resp" onClick={() => this.modalFunAssignments()}>Start Now</Button>)
                                                                                        )

                                                                                       
                                                                                    )

                                                                                    
                                                                                    
                                                                                )
                                                                            }
                                                                            </>
                                                                            
                                                                        )

                                                                        
                                                                    }
                                                                    
                                                                </Col>
                                                            </Row>
                                                            </Media.Body>
                                                        </Media>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                }
                                 {
                                    this.state.examTypeString == "ongoing" && this.state.getExamsNewPattern.length == 0 ?

                                        (
                                            <Col sm={12}>
                                                <div className="no-test">
                                                    Coming Soon
                                                </div>

                                            </Col>
                                        ) : this.state.examTypeString == "attended" && this.state.getExamsNewPattern.length == 0 ?

                                            (
                                                <Col sm={12}>
                                                    <div className="no-test">
                                                        You have not Attempted any Exam
                                                    </div>
                                                </Col>
                                            ) : this.state.examTypeString == "missed" && this.state.getExamsNewPattern.length == 0 ?
                                                (
                                                    <Col sm={12}>
                                                        <div className="no-test">
                                                            No Missed Exams
                                                        </div>

                                                    </Col>
                                                ) : ("")
                                }
                                   
                            </Row>
                        </div>
                    </Col>
                  
                </Row>
                <UserRestrictionAlert
                    show={this.state.userRestionModalShow}
                    onHide={() => this.setState({ userRestionModalShow: false })}
                    planDetailsShow = "2"
                />
                <ViewSyllabus SyllabusDetails={this.state.viewSyllabusDetails} show={this.state.viewSyllabusModal} onHide={() => this.setState({ viewSyllabusModal: false })} />
            </Container>
            
        )
       

        
    }

}

export default withRouter((RepeatersExamsSections));

